import axios from "axios";
import JwtService from "@/common/jwt.service";

const DEFAULT_CONTENT_TYPE = "application/json";

const apiAxios = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  timeout: 10000,
  headers: {
    'Content-Type': DEFAULT_CONTENT_TYPE,
  },
});

const ApiService = {
  init() {
    apiAxios.defaults.baseURL = process.env.VUE_APP_API_URL;

    // Add a request interceptor
    apiAxios.interceptors.request.use(function(config) {
      const token = JwtService.getToken();
      if (token !== "undefined" && token !== null) {
        config.headers.Authorization = `Token ${token}`;
      }
      return config;
    });
  },

  query(resource, params) {
    return apiAxios.get(resource, params);
  },

  get(resource, slug = "") {
    let url = slug ? `${resource}/${slug}` : resource;
    return apiAxios.get(url);
  },

  post(resource, params) {
    return apiAxios.post(`${resource}`, params, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  },

  patch(resource, params) {
    return apiAxios.patch(`${resource}`, params, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  },

  put(resource, params) {
    return apiAxios.put(`${resource}`, params, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  },

  delete(resource) {
    return apiAxios.delete(resource);
  },
};

export default ApiService;
